import { TaskStatus } from "@app/maintenance/components/task/task.model";
import { BaseData } from "@app/maintenance/models/logical-grouper/base-data.model";
import { LinkData } from "@app/maintenance/models/logical-grouper/link-data.model";
import { SelectionData } from "@app/maintenance/models/logical-grouper/selection-data.model";
import tasks from "@app/shared/mock-them-all/tasks";

const newTasks = tasks.filter(t => t.status === TaskStatus.NEW);

const grouperDropdownItems = [
    {
        id: 1,
        title: "1w",
        subtitle: "Recurring once every 1 week",
        icon: "fa fa-clock-o",
        baseData: new BaseData({
            title: "1w",
            subtitle: "Recurring once every 1 week",
            icon: "fa fa-clock-o"
        }),
        selectionData: new SelectionData({
            isSelectable: false,
            isSelected: false,
        }),
        linkData: new LinkData({
            icon: "fa fa-cog",
            label: "Go to plan"
        }),
        tasks: newTasks
    },
    {
        id: 2,
        title: "3d",
        subtitle: "Recurring once every 3 days",
        icon: "fa fa-clock-o",
        baseData: new BaseData({
            title: "3d",
            subtitle: "Recurring once every 3 days",
            icon: "fa fa-clock-o",
            tooltipDescription: "This is a description"
        }),
        selectionData: new SelectionData({
            isSelectable: true,
            isSelected: false,
        }),
        linkData: new LinkData({
            link: "https://www.google.com",
            label: "Go to plan",
            icon: "fa fa-cog"
        }),
        tasks: newTasks
    },
    {
        id: 3,
        title: "1M",
        subtitle: "Recurring once every 1 month",
        icon: "fa fa-clock-o",
        baseData: new BaseData({
            title: "1M",
            subtitle: "Recurring once every 1 month",
            icon: "fa fa-clock-o"
        }),
        selectionData: new SelectionData({
            isSelectable: false,
            isSelected: false,
        }),
        tasks: newTasks
    },
    {
        id: 4,
        title: "100cycles",
            subtitle: "Recurring once every 100 cycles",
            icon: "fa fa-refresh",
            baseData: new BaseData({
                title: "100cycles",
                subtitle: "Recurring once every 100 cycles",
                icon: "fa fa-refresh"
            }),
            selectionData: new SelectionData({
                isSelectable: true,
                isSelected: false,
            }),
            tasks: newTasks
        },
    {
        id: 5,
        title: "return",
        subtitle: "Recurring once every 1 return",
        icon: "fa fa-undo",
        baseData: new BaseData({
            title: "return",
            subtitle: "Recurring once every 1 return",
            icon: "fa fa-undo"
        }),
        selectionData: new SelectionData({
            isSelectable: false,
            isSelected: false,
        }),
        tasks: newTasks
    },
    {
        id: 6,
        title: "return",
        subtitle: "Recurring once every 1 return",
        icon: "fa fa-undo",
        baseData: new BaseData({
            title: "return",
            subtitle: "Recurring once every 1 return",
            icon: "fa fa-undo"
        }),
        selectionData: new SelectionData({
            isSelectable: false,
            isSelected: false,
        }),
        tasks: newTasks
    },
    {
        id: 7,
        title: "return",
        subtitle: "Recurring once every 1 return",
        icon: "fa fa-undo",
        baseData: new BaseData({
            title: "return",
            subtitle: "Recurring once every 1 return",
            icon: "fa fa-undo"
        }),
        selectionData: new SelectionData({
            isSelectable: false,
            isSelected: false,
        }),
        tasks: newTasks
    },

];

export default grouperDropdownItems;
